import { http } from '@shared/api';
import type { UserBasicInfo } from '../model/types';

const MAX_BATCH = 100;

export const userDirectoryApi = {
  basic: (id: string) => http.get(`users/${id}/basic`).json<UserBasicInfo>(),

  basicBatch: (ids: string[]) =>
    http
      .get('users/basic', {
        searchParams: { ids: ids.slice(0, MAX_BATCH).join(',') },
      })
      .json<UserBasicInfo[]>(),
};
